import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import OpenModals from "./OpenModals";

class CurrentView extends Component {
  render() {
    const { stores } = this.props;
    const view = stores.ui.view;
    const currentPageHandler = view.currentPageHandler;

    let contents = null;
    if (currentPageHandler) {
      if (currentPageHandler.component) {
        contents = (
          <currentPageHandler.component
            handler={currentPageHandler}
            {...view.parameters}
          />
        );
      }
    }

    return (
      <React.Fragment>
        {contents}
        <OpenModals />
      </React.Fragment>
    );
  }
}

export default inject("stores")(observer(CurrentView));



// WEBPACK FOOTER //
// ./src/Core/Components/CurrentView.js